import { z } from 'zod';

import type { ZodUseQuery } from '@/utils/zodReactQuery';

export const toolGroupSchema = z.enum(['search', 'account', 'actions', 'conversation']);

export const toolSchema = z.object({
	name: z.string(),
	group: toolGroupSchema,
	gate: z.string().nullable(),
	enabled: z.boolean(),
	callsToday: z.number().int().nonnegative(),
});

export const toolsResponse = z.object({ items: z.array(toolSchema) });

export type Tool = z.infer<typeof toolSchema>;
export type ToolGroup = z.infer<typeof toolGroupSchema>;
export type UseTools = ZodUseQuery<z.infer<typeof toolsResponse>>;
